import {useEffect, useState} from 'react';
import {DateSlot, TimeSlot} from 'components/TimePicker/types';
import {useEvents} from 'hooks/useEvents';
import {useQueryValues} from 'utils/queryObj';

export const useBooking = (slug: string) => {
	const {state, refresh} = useEvents({slug});

	// Appointment selection state tracking
	const [date, setDate] = useState<DateSlot>();
	const [time, setTime] = useState<TimeSlot>();

	const {read, update} = useQueryValues('st');
	const query = read({appt: '', date: ''});

	const setters = {
		setDate: (d?: DateSlot) => {
			setDate(d);
			update({...query, date: d?.date});
			return false;
		},
		setTime: (v?: TimeSlot) => {
			setTime(v);
			update({...query, appt: v?.id});
			return false;
		}
	};

	// Dynamically pop open booking modal if a valid appt is set (or clear)
	useEffect(() => {
		if (time || state.locations.length === 0) {
			return;
		} else if (!query.appt) {
			return;
		}

		// Look through our locations to try to find a match
		for (const location of state.locations) {
			for (const curr of location.datesBase) {

				// Do optimization using date if present
				if (query.date) {
					if (curr.date < query.date) {
						continue;
					} else if (curr.date > query.date) {
						break;
					}
				}

				// Search through times to find match
				for (const time of curr.timesBase) {
					if (time.id === query.appt && time.canReserve) {
						setters.setTime(time);
						return;
					}
				}
			}
		}

		// No match; if no queries pending, clear query arg
		if (!state.loading) {
			setters.setTime(undefined);
		}
	}, [state.locations.length, state.loading]);

	return {
		date,
		time,
		state,
		refresh,
		setters,
	};
};
